import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginService } from '../../../services/login/login.service';
@Component({
  selector: 'app-nueva-empresa-riesgo',
  templateUrl: './nueva-empresa-riesgo.component.html',
  styleUrls: ['./nueva-empresa-riesgo.component.scss']
})
export class NuevaEmpresaRiesgoComponent implements OnInit {

  form: FormGroup;
  loading: boolean;

  idAdq: any;
  rucAdq = new FormControl();
  rucTop = new FormControl();
  rucEmpresa = new FormControl();
  filteredAdquirentes: any;
  filteredEmpresas: any;
  filteredTop: any;
  adquirentesArr: any;
  EmpresasArr: any;
  topArr: any;

  formContactos: FormGroup;
  formEmpresas: FormGroup;
  dataEnviar: any = {};
  ruc: any;
  rucTop10: any;
  rucEmpresas: any;
  user: any;
  sectores: any;
  ranking1: any = [];
  rankingtop: any;
  ranking2: any = [];
  rankingtop2: any;
  edit: boolean = false;
  datariesgo: any;
  prueba: string;
  titulo:string="";
  constructor(private riesgosService: RiesgoService,
    private router: Router,
    private loginService: LoginService) {
    this.ObtenerAdquirentesCombo();
    this.ObtenerTopCombo();
    this.ObtenerEmpresasCombo();
    console.log(this.riesgosService.dataExcepciones);
    
    if (this.riesgosService.dataExcepciones == 0) {
      this.edit = false;
      this.titulo = "Crear Relación";
    } else {
      this.edit = true;
      this.titulo = "Editar Relación";
      this.datariesgo = this.riesgosService.dataExcepciones;
      this.prueba = this.riesgosService.dataExcepciones.Tipo_relacion.toString();
      this.rucAdq.setValue(this.riesgosService.dataExcepciones.Num_Doc_Identificacion)
    }
    if (this.edit == true) {
      this.rucTop.setValue(this.datariesgo.RUC);
      this.formContactos = new FormGroup({
        Razon_Social: new FormControl({ value: this.datariesgo.Razon_Social, disabled: true }, [Validators.required]),
        Sector_Economico: new FormControl(this.datariesgo.idSector_Adquirente, [Validators.required]),
        Moneda: new FormControl(this.prueba, [Validators.required]),
        Usuario: new FormControl(""),
        Ranking: new FormControl({ value: this.datariesgo.Scoring_Puntaje, disabled: true }, [Validators.required]),
        flag: new FormControl(true),
        Razon_Social_top: new FormControl({ value: this.datariesgo.RazonSocial, disabled: true }),
        Sector_Economico_top: new FormControl({ value: this.datariesgo.SectorEconomico, disabled: true }),
        Ranking_top: new FormControl({ value: this.datariesgo.Ranking, disabled: true }),
        Razon_Sociall2: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Sector_Economicoo2: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Usuarioo2: new FormControl(""),
        Rankingg2: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Observaciones: new FormControl(""),
      });
    } else {
      this.formContactos = new FormGroup({
        Razon_Social: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Sector_Economico: new FormControl("", [Validators.required]),
        Moneda: new FormControl("", Validators.required),
        Usuario: new FormControl(""),
        Ranking: new FormControl({ value: "", disabled: true }, [Validators.required]),
        flag: new FormControl(false),
        Razon_Social_top: new FormControl({ value: "", disabled: true }),
        Sector_Economico_top: new FormControl({ value: "", disabled: true }),
        Ranking_top: new FormControl({ value: "", disabled: true }),
        Razon_Sociall2: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Sector_Economicoo2: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Usuarioo2: new FormControl(""),
        Rankingg2: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Observaciones: new FormControl(""),
      });
    }
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    console.log(this.edit);
  }

  ngOnInit() {
    this.ListarSectores();
  }

  obtenerAdRazSocial(terminoAD: string = '') {
    if (terminoAD != null && terminoAD != '') {
      let terminoAD1 = terminoAD.toLowerCase();
      for (let a of this.adquirentesArr) {
        let raz = a.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(terminoAD1) >= 0) {
          this.idAdq = a.idEmpresa;
        }
      }
    }
  }

  obtenerEmpRazSocial(terminoAD: string = '') {
    if (terminoAD != null && terminoAD != '') {
      let terminoAD1 = terminoAD.toLowerCase();
      for (let a of this.EmpresasArr) {
        let raz = a.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(terminoAD1) >= 0) {
          this.idAdq = a.idEmpresa;
        }
      }
    }
  }

  obtenerTopSocial(terminoAD: string = '') {
    if (terminoAD != null && terminoAD != '') {
      let terminoAD1 = terminoAD.toLowerCase();
      for (let a of this.topArr) {
        let raz = a.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(terminoAD1) >= 0) {
          this.idAdq = a.idEmpresa;
        }
      }
    }
  }

  ObtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAd(state) : this.adquirentesArr.slice()
        )
      );
  }

  ObtenerEmpresasCombo() {
    this.EmpresasArr = JSON.parse(sessionStorage.getItem('lstCliCbo'));
    this.filteredEmpresas = this.rucEmpresa.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterEmp(state) : this.EmpresasArr.slice()
        )
      );
  }

  ObtenerTopCombo() {
    this.topArr = JSON.parse(sessionStorage.getItem('lstTopCbo'));
    this.filteredTop = this.rucTop.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filtertp(state) : this.topArr.slice()
        )
      );
  }

  private _filterAd(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
        state.Num_Doc_Identificacion.toLowerCase().includes(filterValue) === true
    );
  }

  private _filtertp(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.topArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
        state.RUC.toLowerCase().includes(filterValue) === true
    );
  }

  private _filterEmp(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.EmpresasArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
        state.Num_Doc_Identificacion.toLowerCase().includes(filterValue) === true
    );
  }

  ListarSectores() {
    this.loading = true;
    this.riesgosService.obtenerSectoresEconomicos().subscribe(
      res => {
        this.sectores = res;
        this.sectores = this.sectores.filter(est => est.Estado == "A");
        this.loading = false;
      }
    )
  }

  obtenerIdAdq(element) {
    this.ranking1 = this.topArr.filter(est => est.idEmpresa == element.idEmpresa);
    if (this.ranking1.length == 0) {
      this.formContactos.controls['Ranking'].setValue("No tiene Ranking");
    } else {
      this.formContactos.controls['Ranking'].setValue(this.ranking1[0].Ranking);
    }
    this.formContactos.controls['Razon_Social'].setValue(element.Razon_Social);
    this.formContactos.controls['Sector_Economico'].setValue(element.SectorEconomico);
    this.formContactos.controls['Moneda'].setValue(element.Moneda);

    this.ruc = element.Num_Doc_Identificacion;

  }

  obtenerIdTop(element) {
    this.formContactos.controls['Razon_Social_top'].setValue(element.Razon_Social);
    this.formContactos.controls['Sector_Economico_top'].setValue(element.SectorEconomico);
    this.formContactos.controls['Ranking_top'].setValue(element.Ranking);
    this.rucTop10 = element.RUC;
  }

  obtenerEmpTopo(element) {
    this.ranking2 = this.topArr.filter(est => est.idEmpresa == element.idEmpresa);
    if (this.ranking2.length == 0) {
      this.formContactos.controls['Rankingg2'].setValue("No tiene Ranking");
    } else {
      this.formContactos.controls['Rankingg2'].setValue(this.ranking2[0].Ranking);
    }
    this.formContactos.controls['Razon_Sociall2'].setValue(element.Razon_Social);
    this.formContactos.controls['Sector_Economicoo2'].setValue(element.idSector);
    this.rucEmpresas = element.Num_Doc_Identificacion;
  }

  isChecked() {
    if (this.formContactos.controls["flag"].value == false) {
      this.formContactos.controls['Razon_Social_top'].setValue("");
      this.formContactos.controls['Sector_Economico_top'].setValue("");
      this.formContactos.controls['Ranking_top'].setValue("");
      this.rucTop.setValue('');
      this.rucTop10 = "";
    }
  }

  clear() {
    this.formContactos.controls['Razon_Social_top'].setValue("");
    this.formContactos.controls['Sector_Economico_top'].setValue("");
    this.formContactos.controls['Ranking_top'].setValue("");
    this.rucTop.setValue('');
    this.rucTop10 = "";
  }

  AgregarExcepcion() {
    if (this.edit == true) {
      this.editar();
    } else {
      this.dataEnviar.Ruc = this.ruc;
      this.dataEnviar.Tipo = this.formContactos.controls['Moneda'].value;
      this.dataEnviar.Usuario = this.user.Usuario;
      this.dataEnviar.SectorEconomico = this.formContactos.controls['Sector_Economico'].value;
      this.dataEnviar.RUC_TOP = 0
      this.dataEnviar.Estado = 1
      this.dataEnviar.Razon = ""
      if (this.formContactos.controls['Ranking'].value == "No tiene Ranking") {
        this.dataEnviar.Ranking = 0;
      } else {
        this.dataEnviar.Ranking = this.formContactos.controls['Ranking'].value;
      }
      if (this.formContactos.controls["flag"].value == true && this.rucTop10 == "") {
        Swal.fire({
          title: 'Ingresar Empresa Relacionada',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        return;
      } 
      if (this.formContactos.controls["flag"].value == true) {
        this.dataEnviar.RUC_TOP = this.rucTop10;
      }
      Swal.fire({
        title: '¡Espere por favor!',
        text: 'Estamos guardado la información.',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      Swal.showLoading();
      this.riesgosService.RegistrarExcepcion(this.dataEnviar)
        .subscribe(resp => {
          Swal.fire({
            title: "¡Éxito!",
            text: 'Empresa registrado correctamente.',
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(resp1 => {
            if (resp1.value == true) {
              this.loginService.clickGuard = true;
              this.router.navigate(['/riesgo/empresa/excepciones']);
            }
          });
        }, (err: HttpErrorResponse) => {
          Swal.fire({
            title: "¡Error!",
            text: err.error.error,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          })
        })
    }
  }
  editar(){
    this.loading = true;
      this.dataEnviar.id = this.riesgosService.dataExcepciones.idTop10K_Excepciones;
      this.dataEnviar.Ruc = this.ruc;
      this.dataEnviar.Tipo = this.formContactos.controls['Moneda'].value;
      this.dataEnviar.SectorEconomico = this.formContactos.controls['Sector_Economico'].value;
      this.dataEnviar.Estado = 1;
      this.dataEnviar.Usuario = this.user.Usuario;
      this.dataEnviar.Razon = "";
      if (this.formContactos.controls["flag"].value == true) {
        this.dataEnviar.RUC_TOP = this.rucTop10;
      }
      this.riesgosService.EditarExcepcion(this.dataEnviar)
        .subscribe(res => {
          this.loading = false;
          Swal.fire(
            'Relacion Actualizada',
            ' ',
            'success'
          )
            .then(resp => {
              this.loginService.clickGuard = true;
            this.router.navigate(['/riesgo/empresa/excepciones']);
            });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          console.log(err);
          Swal.fire({
            title: err.error.error,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          })
        })
  }

  AgregarListaNegra() {
    this.dataEnviar.Ruc = this.rucEmpresas;
    this.dataEnviar.Tipo = 0;
    this.dataEnviar.Usuario = this.user.Usuario;
    this.dataEnviar.SectorEconomico = this.formContactos.controls['Sector_Economicoo2'].value;
    this.dataEnviar.RUC_TOP = 0
    this.dataEnviar.Estado = 0
    this.dataEnviar.Razon = this.formContactos.controls['Observaciones'].value;
    if (this.formContactos.controls['Ranking'].value == "No tiene Ranking") {
      this.dataEnviar.Ranking = 0;
    } else {
      this.dataEnviar.Ranking = this.formContactos.controls['Rankingg2'].value;
    }
    Swal.fire({
      title: '¡Espere por favor!',
      text: 'Estamos guardado la información.',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    this.riesgosService.RegistrarExcepcion(this.dataEnviar)
      .subscribe(resp => {
        Swal.fire({
          title: "¡Éxito!",
          text: 'Se agrego a la lista Negra.',
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(resp2 => {
          if (resp2.value == true) {
            this.loginService.clickGuard = true;
            this.router.navigate(['/riesgo/empresa/listaNegra']);
          }
        });
      }, (err1: HttpErrorResponse) => {
        Swal.fire({
          title: "¡Error ",
          text: err1.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        })
      })
  }

}



